import React, { useState, useEffect, useReducer } from "react";
import { useQuery, gql } from "@apollo/client";
import Spinner from "../common/Spinner";

const POSTS_QUERY = gql`
  {
    posts {
      title
      slug
      coverImage {
        url
      }
      content {
        text
      }
      categories {
        categoryName
      }
      url
      tags
    }
  }
`;

const CATRGORIES_QUERY = gql`
  {
    categories {
      categoryName
      id
    }
  }
`;

const pagination = (itemsPerPage, totalItems, paginate, currentPage) => {
  const pageNmbers = [];
  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNmbers.push(i);
  }
  if (pageNmbers.length > 1) {
    return (
      <ul className="pagination orange-text text-darken-4">
        <li className="waves-effect">
          <a
            className="orange-text text-darken-4"
            onClick={
              pageNmbers.length > 1 && currentPage !== 1
                ? (e) => paginate(e, 1, false)
                : null
            }
          >
            <i className="material-icons">chevron_left</i>
          </a>
        </li>
        {pageNmbers.map((number) => (
          <li
            className={`waves-effect ${currentPage === number ? "active" : ""}`}
            key={number}
          >
            <a
              onClick={
                pageNmbers.length > 1 ? (e) => paginate(e, number, true) : null
              }
            >
              {number}
            </a>
          </li>
        ))}
        <li className="waves-effect orange-text text-darken-4">
          <a
            className="orange-text text-darken-4"
            onClick={
              pageNmbers.length > 1 && currentPage !== pageNmbers.length
                ? (e) => paginate(e, pageNmbers.length, false)
                : null
            }
          >
            <i className="material-icons">chevron_right</i>
          </a>
        </li>
      </ul>
    );
  }
};

const removeAndAddActiveClass = (item, id, isElement) => {
  let elements = item.parentElement.children;
  for (let i = 0; i < elements.length; i++) {
    elements[i].removeAttribute("class");
    if (elements[i].id === id) {
      elements[i].classList.add("active");
    }
  }
};

function renderPosts(currentItems, isTablet) {
  if (currentItems.length > 0) {
    return currentItems.map((item) => {
      return (
        <div key={item.url} className={`col s12 ${isTablet ? "m12" : "m6"}`}>
          <div className="card">
            <div className="card-image">
              <a href={item.url}>
                <img
                  className="activator"
                  src={item.coverImage.url}
                  alt={item.slug}
                  loading="lazy"
                />
              </a>
            </div>
            <div className="card-content">
              <p>{item.title}</p>
            </div>
          </div>
        </div>
      );
    });
  } else {
    return (
      <div
        className="col s12 m12"
        style={{ marginBottom: "300px", marginTop: "20px" }}
      >
        <h4>Keine Artikel wurden gefunden</h4>
      </div>
    );
  }
}

function getTages(posts, setTags) {
  let foundTags = [];
  let newTags = [];
  for (let i = 0; i < posts.length; i++) {
    const itemTags = posts[i].tags;
    if (itemTags.length > 0) {
      for (let j = 0; j < itemTags.length; j++) {
        const tag = itemTags[j];
        if (
          foundTags.indexOf(tag.toLowerCase()) === -1 &&
          foundTags.indexOf(tag) === -1
        ) {
          foundTags.push(tag);
        }
      }
    }
  }
  if (foundTags.length <= 10) {
    newTags = foundTags;
  } else {
    while (newTags.length < 11) {
      const randomTag = foundTags[Math.floor(Math.random() * foundTags.length)];
      if (newTags.indexOf(randomTag) === -1) {
        newTags.push(randomTag);
      }
    }
  }
  setTags(newTags);
}

function resetSearch(e, setSearchText, setSelectedCategories, setSelectedTags) {
  e.preventDefault();
  setSearchText("");
  setSelectedCategories([]);
  setSelectedTags([]);
}

function renderSelectedTags(selectedTags, removeTag) {
  return selectedTags.map((selectedTag) => {
    return (
      <div className="chip" key={selectedTag}>
        {selectedTag}
        <i
          id={selectedTag}
          className="remove material-icons"
          onClick={removeTag}
        >
          close
        </i>
      </div>
    );
  });
}

function renderCategories(
  selectedCategories,
  title,
  id,
  isTablet,
  handelSelectedCategoriesChange
) {
  return (
    <div key={id} className={`col s12 m12}`} style={{ marginBottom: "-20px" }}>
      <p>
        <label className="orange-text text-darken-4">
          <input
            id={title}
            type="checkbox"
            checked={selectedCategories.indexOf(title) !== -1}
            onChange={handelSelectedCategoriesChange}
          />
          <span>{title}</span>
        </label>
      </p>
    </div>
  );
}

function renderTags(tags, addTag) {
  let index = 0;
  return tags.map((tag) => {
    index = index + 1;
    return (
      <a
        key={index}
        id={tag}
        className="waves-effect waves-light btn orange darken-4"
        style={{ margin: "10px 5px 1px 1px" }}
        onClick={addTag}
      >
        {tag}
      </a>
    );
  });
}

function filterItems(
  items,
  searchText,
  selectedCategories,
  selectedTags,
  setPosts
) {
  let filteredItems = [];
  if (
    selectedCategories.length === 0 &&
    selectedTags.length === 0 &&
    searchText !== ""
  ) {
    for (let i = 0; i < items.length; i++) {
      if (
        items[i].title.toLowerCase().indexOf(searchText.toLowerCase()) !== -1 ||
        items[i].content.text
          .toLowerCase()
          .indexOf(searchText.toLowerCase()) !== -1 ||
        items[i].slug.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
      ) {
        filteredItems.push(items[i]);
      }
    }
  } else if (
    selectedCategories.length !== 0 &&
    selectedTags.length === 0 &&
    searchText === ""
  ) {
    for (let j = 0; j < items.length; j++) {
      if (items[j].categories.length > 0) {
        if (
          items[j].categories.some(
            (x) => selectedCategories.indexOf(x.categoryName) !== -1
          )
        ) {
          filteredItems.push(items[j]);
        }
      }
    }
  } else if (
    selectedCategories.length !== 0 &&
    selectedTags.length === 0 &&
    searchText !== ""
  ) {
    for (let k = 0; k < items.length; k++) {
      if (items[k].categories.length > 0) {
        if (
          (items[k].title.toLowerCase().indexOf(searchText.toLowerCase()) !==
            -1 ||
            items[k].content.text
              .toLowerCase()
              .indexOf(searchText.toLowerCase()) !== -1 ||
            items[k].slug.toLowerCase().indexOf(searchText.toLowerCase()) !==
              -1) &&
          items[k].categories.some(
            (x) => selectedCategories.indexOf(x.categoryName) !== -1
          )
        ) {
          filteredItems.push(items[k]);
        }
      }
    }
  } else if (
    selectedCategories.length === 0 &&
    selectedTags.length !== 0 &&
    searchText === ""
  ) {
    for (let f = 0; f < items.length; f++) {
      if (items[f].tags.length > 0) {
        if (items[f].tags.some((x) => selectedTags.indexOf(x) !== -1)) {
          filteredItems.push(items[f]);
        }
      }
    }
  } else if (
    selectedCategories.length === 0 &&
    selectedTags.length !== 0 &&
    searchText !== ""
  ) {
    for (let g = 0; g < items.length; g++) {
      if (items[g].tags.length > 0) {
        if (
          (items[g].title.toLowerCase().indexOf(searchText.toLowerCase()) !==
            -1 ||
            items[g].content.text
              .toLowerCase()
              .indexOf(searchText.toLowerCase()) !== -1 ||
            items[g].slug.toLowerCase().indexOf(searchText.toLowerCase()) !==
              -1) &&
          items[g].tags.some((x) => selectedTags.indexOf(x) !== -1)
        ) {
          filteredItems.push(items[g]);
        }
      }
    }
  } else if (
    selectedCategories.length !== 0 &&
    selectedTags.length !== 0 &&
    searchText === ""
  ) {
    for (let h = 0; h < items.length; h++) {
      if (items[h].categories.length > 0 && items[h].tags.length) {
        if (
          items[h].tags.some((x) => selectedTags.indexOf(x) !== -1) &&
          items[h].categories.some(
            (x) => selectedCategories.indexOf(x.categoryName) !== -1
          )
        ) {
          filteredItems.push(items[h]);
        }
      }
    }
  } else if (
    selectedCategories.length !== 0 &&
    selectedTags.length !== 0 &&
    searchText !== ""
  ) {
    for (let l = 0; l < items.length; l++) {
      if (items[l].categories.length > 0 && items[l].tags.length) {
        if (
          (items[l].title.toLowerCase().indexOf(searchText.toLowerCase()) !==
            -1 ||
            items[l].content.text
              .toLowerCase()
              .indexOf(searchText.toLowerCase()) !== -1 ||
            items[l].slug.toLowerCase().indexOf(searchText.toLowerCase()) !==
              -1) &&
          items[l].tags.some((x) => selectedTags.indexOf(x) !== -1) &&
          items[l].categories.some(
            (x) => selectedCategories.indexOf(x.categoryName) !== -1
          )
        ) {
          filteredItems.push(items[l]);
        }
      }
    }
  }
  setPosts(filteredItems);
}

function GetPosts(props) {
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [posts, setPosts] = useState([]);
  const [allPosts, setAllPosts] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage] = useState(6);
  const { loading, error, data } = useQuery(POSTS_QUERY);
  const loadingCat = useQuery(CATRGORIES_QUERY).loading;
  const errorCat = useQuery(CATRGORIES_QUERY).error;
  const dataCat = useQuery(CATRGORIES_QUERY).data;

  useEffect(() => {
    const fetchPosts = () => {
      const fetchedPosts = data;
      if (data) {
        setAllPosts(fetchedPosts.posts);
        getTages(fetchedPosts.posts, setTags);
        if (
          searchText === "" &&
          selectedCategories.length === 0 &&
          selectedTags.length === 0
        ) {
          setPosts(fetchedPosts.posts);
        } else {
          filterItems(
            fetchedPosts.posts,
            searchText,
            selectedCategories,
            selectedTags,
            setPosts
          );
        }
      }
    };
    const fetchCategories = () => {
      const fetchedCategories = dataCat;
      if (dataCat) {
        setCategories(fetchedCategories.categories);
      }
    };
    fetchPosts();
    fetchCategories();
  }, [data, dataCat, searchText, selectedCategories, selectedTags]);

  const handelSearchChange = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
  };

  const addTag = (e) => {
    if (selectedTags.indexOf(e.target.id) === -1) {
      selectedTags.push(e.target.id);
      setSelectedTags(selectedTags);
      forceUpdate();
      filterItems(
        allPosts,
        searchText,
        selectedCategories,
        selectedTags,
        setPosts
      );
    }
  };

  const removeTag = (e) => {
    let id = e.target.id;
    let newSelectedTags = selectedTags.filter((x) => x !== id);
    setSelectedTags(newSelectedTags);
  };

  const handelSelectedCategoriesChange = (e) => {
    let selectedCats = selectedCategories;
    e.target.checked
      ? selectedCats.push(e.target.id)
      : (selectedCats = selectedCats.filter((x) => x !== e.target.id));
    setSelectedCategories(selectedCats);
    filterItems(
      allPosts,
      searchText,
      selectedCategories,
      selectedTags,
      setPosts
    );
    setCurrentPage(1);
  };

  const indexOfLastItem = currentPage * postPerPage;
  const indexOfFirstItem = indexOfLastItem - postPerPage;
  const currentItems = posts.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (event, pagNumber, isElement) => {
    removeAndAddActiveClass(
      isElement
        ? event.target.parentElement
        : event.target.parentElement.parentElement,
      pagNumber,
      isElement
    );
    setCurrentPage(pagNumber);
  };

  if (loading || loadingCat) return <Spinner />;
  if (error || errorCat) return <p>Ein Fehler ist aufgetreten :(</p>;

  return (
    <div className="section">
      {props.isTablet || props.isMobile ? (
        <React.Fragment>
          <div className="row">
            <div className="col s12 m12">
              <div className="input-field col s12">
                <i className="material-icons prefix">search</i>
                <input
                  value={searchText}
                  id="firstAndLastName"
                  type="text"
                  onChange={handelSearchChange}
                />
                <label htmlFor="firstAndLastName">Finden</label>
              </div>
            </div>
            <div
              className="col s12 m6"
              style={{
                marginTop: "30px",
                marginBottom: "10px",
                fontWeight: "600",
                fontSize: "20px",
              }}
            >
              <span>Kategorien</span>
              {categories.map(({ categoryName, id }) =>
                renderCategories(
                  selectedCategories,
                  categoryName,
                  id,
                  props.isTablet,
                  handelSelectedCategoriesChange
                )
              )}
            </div>
            <div
              className="col s12 m6"
              style={{
                marginTop: "30px",
                fontWeight: "600",
                fontSize: "20px",
              }}
            >
              <span>Tags</span>
              {selectedTags.length > 0 ? (
                <div className="chips">
                  {renderSelectedTags(selectedTags, removeTag)}
                </div>
              ) : (
                ""
              )}
              <div style={{ marginTop: "20px" }}>
                {renderTags(tags, addTag)}
              </div>
            </div>
            <div
              className="col s12 m12 center"
              style={{ marginTop: "60px", marginBottom: "50px" }}
            >
              <a
                className="waves-effect waves-light grey darken-3 btn"
                style={{ margin: "10px 5px 1px 1px" }}
                onClick={(e) =>
                  resetSearch(
                    e,
                    setSearchText,
                    setSelectedCategories,
                    setSelectedTags
                  )
                }
              >
                Alles zurücksetzen
              </a>
              <hr />
            </div>
            <div className="col s12 m12">
              {renderPosts(currentItems, props.isTablet)}
            </div>
          </div>
          <div className="row center">
            <div className="col s12 m12">
              {pagination(postPerPage, posts.length, paginate, currentPage)}
            </div>
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className="row">
            <div className="col s12 m8">
              {renderPosts(currentItems, props.isTablet)}
            </div>
            <div className="col s12 m3">
              <div className="input-field col s12">
                <i className="material-icons prefix">search</i>
                <input
                  value={searchText}
                  id="firstAndLastName"
                  type="text"
                  onChange={handelSearchChange}
                />
                <label htmlFor="firstAndLastName">Finden</label>
              </div>
            </div>
            <div
              className="col s12 m3 offset-m1"
              style={{
                marginTop: "30px",
                marginBottom: "10px",
                fontWeight: "600",
                fontSize: "20px",
              }}
            >
              <span>Kategorien</span>
            </div>
            <div className="col s12 m3 offset-m1" style={{ marginTop: "21px" }}>
              {categories.map(({ categoryName, id }) =>
                renderCategories(
                  selectedCategories,
                  categoryName,
                  id,
                  props.isTablet,
                  handelSelectedCategoriesChange
                )
              )}
            </div>
            <div
              className="col s12 m3 offset-m1"
              style={{
                marginTop: "30px",
                fontWeight: "600",
                fontSize: "20px",
                float: "right",
              }}
            >
              <span>Tags</span>
              {selectedTags.length > 0 ? (
                <div className="chips">
                  {renderSelectedTags(selectedTags, removeTag)}
                </div>
              ) : (
                ""
              )}
              <div style={{ marginTop: "20px" }}>
                {renderTags(tags, addTag)}
              </div>
              <div className="center" style={{ marginTop: "60px" }}>
                <hr />
                <a
                  className="waves-effect waves-light grey darken-3 btn"
                  style={{ margin: "10px 5px 1px 1px" }}
                  onClick={(e) =>
                    resetSearch(
                      e,
                      setSearchText,
                      setSelectedCategories,
                      setSelectedTags
                    )
                  }
                >
                  Alles zurücksetzen
                </a>
              </div>
            </div>
          </div>
          <div className="row center">
            <div className="col s12 m8">
              {pagination(postPerPage, posts.length, paginate, currentPage)}
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
}

export default GetPosts;



// WEBPACK FOOTER //
// ./src/components/services/posts.js